// Ocorrencias futuras das publicacoes recorrentes para o calendario (puro).

import { listOccurrences } from "@lucralink/shared";
import type { RecurringPost } from "@/lib/hooks/useRecurringPosts";

export interface RecurringOccurrence {
  readonly recurringId: string;
  readonly at: Date;
  readonly bodyText: string;
  readonly destinations: number;
}

const MAX_PER_POST = 200;

/** YYYY-MM-DD no fuso de Sao Paulo. */
export function saoPauloDateKey(date: Date): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "America/Sao_Paulo" }).format(date);
}

/** Primeiro instante do mes (Sao Paulo) e o primeiro do mes seguinte. */
export function monthRange(year: number, month: number): { from: Date; until: Date } {
  const pad = (n: number): string => String(n).padStart(2, "0");
  const next = month === 11 ? { y: year + 1, m: 0 } : { y: year, m: month + 1 };
  return {
    from: new Date(`${year}-${pad(month + 1)}-01T00:00:00-03:00`),
    until: new Date(new Date(`${next.y}-${pad(next.m + 1)}-01T00:00:00-03:00`).getTime() - 1),
  };
}

/** Ocorrencias futuras (a partir de agora) das recorrencias ativas, por dia. */
export function recurringOccurrencesByDate(
  posts: readonly RecurringPost[],
  from: Date,
  until: Date,
  now: Date = new Date(),
): Map<string, RecurringOccurrence[]> {
  const map = new Map<string, RecurringOccurrence[]>();
  const start = from > now ? from : now;
  for (const post of posts) {
    if (post.status !== "active" || !post.rule) continue;
    const spec = { rule: post.rule, startsAt: new Date(post.startsAt), endsAt: post.endsAt ? new Date(post.endsAt) : null };
    for (const at of listOccurrences(spec, start, until, MAX_PER_POST)) {
      const key = saoPauloDateKey(at);
      const list = map.get(key) ?? [];
      map.set(key, [...list, { recurringId: post.id, at, bodyText: post.bodyText, destinations: post.deliveries.length }]);
    }
  }
  for (const [key, list] of map) map.set(key, [...list].sort((a, b) => a.at.getTime() - b.at.getTime()));
  return map;
}
